import selectors from 'src/modules/prompt/list/promptListSelectors';
import {
  // faEdit,
  // faTrashAlt,
  faBoxOpen,
  faSpinner,
  faUser,
  faUserTie,
  faCommentAlt,
  faGripHorizontal,
  faStickyNote,
  faPlus,
  faPlayCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tab } from '@headlessui/react';
import actions from 'src/modules/prompt/list/promptListActions';
import destroySelectors from 'src/modules/prompt/destroy/promptDestroySelectors';
// import editActions from 'src/modules/prompt/form/promptFormActions';
import editSelectors from 'src/modules/prompt/form/promptFormSelectors';
import PromptFormModal from 'src/view/prompt/form/PromptFormModal';
import PromptParamsFormModal from 'src/view/prompt/form/PromptParamsFormModal';
import PromptService from 'src/modules/prompt/promptService';
import Pagination from 'src/view/shared/table/Pagination';
import { getHistory } from 'src/modules/store';
import Layout from '../layout/Layout';
import { i18n } from 'src/i18n';
import VideoTutorialPopup from '../common/videoTutorialPopup';
import ReactTooltip from 'react-tooltip';

const GuestPage = () => {
  const dispatch = useDispatch();
  const [isEditPromptModalOpen, setEditPromptModalIsOpen] = useState(false);
  const fetchPrompts = () => {
    dispatch(actions.doFetch({ isPublic: true, guest: true }));
  };

  const pagination = useSelector(selectors.selectPagination);

  const doChangePagination = (pagination) => {
    dispatch(actions.doChangePagination(pagination));
  };
  const [isPromptModalOpen, setPromptModalIsOpen] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [promptParameters, setPromptParameters] = useState([]);
  const [promptIdToInitApp, setPromptIdToInitApp] = useState(null);
  const initLoading = useSelector(editSelectors.selectInitLoading);
  const saveLoading = useSelector(editSelectors.selectSaveLoading);
  const record = useSelector(editSelectors.selectRecord);
  const [promptName, setPromptname] = useState('');
  const [isPublic, setIsPublic] = useState(true);

  const findLoading = useSelector(selectors.selectLoading);

  const destroyLoading = useSelector(destroySelectors.selectLoading);

  const loading = findLoading || destroyLoading;

  const prompts = useSelector(selectors.selectRows);

  const closePromptModal = () => {
    setPromptModalIsOpen(false);
  };

  const doOpenApplication = () => {
    closePromptModal();
  };

  const openPromptModal = (parameters) => {
    setPromptParameters(parameters);
  };

  const setPromptId = (id) => {
    setPromptIdToInitApp(id);
  };

  const handlePromptClick: any = async (prompt) => {
    setIsLoadingData(true);
    const { whoAmI, withWhom, topic } = await PromptService.find(
      prompt.id,
      prompt.tenant
    );
    setIsLoadingData(false);
    openPromptModal({ whoAmI, withWhom, topic });
    setPromptModalIsOpen(true);
    setPromptId(prompt.id);
    setPromptname(prompt.name);
  };

  useEffect(() => {
    fetchPrompts();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Layout>
        <div className='flex flex-col items-center'>
          <Tab.Group>
            <div className='flex flex-col justify-between w-full gap-2 lg:flex-row'>
              <Tab.List className='flex w-full text-sm font-medium text-center text-gray-500 lg:w-1/2 dark:text-white'>
                <Tab as={Fragment}>
                  <button
                    onClick={() => setIsPublic(true)}
                    className={`inline-block rounded-l ${
                      isPublic ? 'bg-blue-500 text-white' : 'bg-gray-600'
                    }   px-2 py-1 my-2 text-xs font-medium uppercase leading-normal text-white transition duration-500 ease-in-out hover:bg-blue-500 focus:bg-blue-500 focus:outline-none focus:ring-0 active:bg-blue-700`}
                  >
                    <FontAwesomeIcon className='mr-2' icon={faGripHorizontal} />
                    {i18n('dashboard.label.public')}
                  </button>
                </Tab>
                <Tab as={Fragment}>
                  <>
                    <button
                      onClick={() => {
                        setIsPublic(false);
                        getHistory().push('/auth/signin');
                        //@ts-ignore
                        localStorage.setItem('isPublic', false);
                      }}
                      className={`inline-block rounded-r ${
                        isPublic ? 'bg-gray-600' : 'bg-blue-500 text-white'
                      }   px-2 py-1 my-2 text-xs font-medium uppercase leading-normal text-white transition duration-500 ease-in-out hover:bg-blue-500 focus:bg-blue-500 focus:outline-none focus:ring-0 active:bg-blue-700`}
                    >
                      <FontAwesomeIcon className='mr-2' icon={faStickyNote} />
                      {i18n('dashboard.label.own')}
                    </button>
                    <div className='py-2 w-0.5 bg-gray-500 mx-2 mr-6'></div>
                  </>
                </Tab>
                <button
                  onClick={() => {
                    localStorage.setItem('newPrompt', 'newPrompt');
                    getHistory().push('/auth/signin');
                  }}
                  className='inline-block px-2 py-1 my-2 mr-4 text-sm text-gray-700 bg-green-300 rounded-md hover:bg-green-500 duration-500 focus:outline-none'
                >
                  <FontAwesomeIcon className='mr-3' icon={faPlus} />
                  Create Prompt
                </button>
              </Tab.List>
              <Tab as={Fragment}>
                <>
                  <VideoTutorialPopup
                    videoUrl='https://www.youtube.com/embed/f0ox8ExXdfo'
                    icon={faPlayCircle}
                    buttonLabel='Watch Tutorial Video (2 min)'
                    className={`px-2 py-3 my-2 mr-4 lg:ml-52 md:mx-auto`}
                  />
                </>
              </Tab>
            </div>
            <Tab.Panels className='w-full mt-8'>
              <Tab.Panel className='flex flex-col items-center justify-center'>
                {prompts && prompts.length > 0 ? (
                  <div>
                    <div className='gap-3.5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-4 w-full'>
                      {prompts.map((prompt) => (
                        <div
                          style={{ display: 'flex', flexDirection: 'column' }}
                          key={prompt.id}
                          onClick={() => {
                            handlePromptClick(prompt);
                          }}
                          className='relative h-72 px-5 py-5 mr-2 bg-gray-200 rounded-md cursor-pointer hover:bg-gray-300 dark:bg-gray-600 dark:text-white dark:hover:bg-gray-700 group'
                        >
                          <h1 className='w-2/3 mt-1 mb-2 text-xl'>
                            {prompt.name}
                          </h1>
                          <hr className='bg-white mb-2' />
                          <div className='flex items-start'>
                            <div>
                              <FontAwesomeIcon icon={faUser} className='mr-6' />
                            </div>
                            <div
                              className='w-54 truncate'
                              data-tip={prompt.whoAmI}
                              data-for='whoAmI'
                            >
                              {prompt.whoAmI}
                              <ReactTooltip
                                className='w-72 h-auto whitespace-normal'
                                id='whoAmI'
                                effect='solid'
                                place='top'
                              />
                            </div>
                          </div>
                          <div className='flex items-start my-4'>
                            <div>
                              <FontAwesomeIcon
                                icon={faUserTie}
                                className='mr-6'
                              />
                            </div>
                            <div
                              className='w-54 truncate'
                              data-tip={prompt.withWhom}
                              data-for='withWhom'
                            >
                              {prompt.withWhom}
                            </div>
                            <ReactTooltip
                              id='withWhom'
                              effect='solid'
                              place='top'
                            />
                          </div>
                          {prompt.topic && (
                            <div className='flex'>
                              <div>
                                <FontAwesomeIcon
                                  icon={faCommentAlt}
                                  className='mr-6'
                                />
                              </div>
                              <div
                                className='w-54 truncate'
                                data-tip={prompt.topic}
                                data-for='topic'
                              >
                                {prompt.topic}
                              </div>
                            </div>
                          )}

                          <ReactTooltip id='topic' effect='solid' place='top' />
                        </div>
                      ))}
                    </div>
                    <div>
                      <div className='mt-12'>
                        <Pagination
                          onChange={doChangePagination}
                          disabled={loading}
                          pagination={pagination}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='flex flex-col items-center mt-8'>
                    <FontAwesomeIcon
                      icon={faBoxOpen}
                      size='10x'
                      className='opacity-50'
                    />
                    <h3 className='my-3 text-center'>No Public Templates</h3>
                  </div>
                )}
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>

          {isPromptModalOpen && (
            <PromptParamsFormModal
              promptName={promptName}
              parameters={promptParameters}
              prompt={promptIdToInitApp}
              onClose={closePromptModal}
              onSuccess={doOpenApplication}
            />
          )}

          {isEditPromptModalOpen && (
            <PromptFormModal
              saveLoading={saveLoading}
              initLoading={initLoading}
              record={record}
              isEditing={true}
              onClose={() => setEditPromptModalIsOpen(false)}
              onSuccess={() => {
                fetchPrompts();
                setEditPromptModalIsOpen(false);
              }}
            />
          )}
          {(isLoadingData || findLoading) && (
            <>
              <div className='text-center'>
                <FontAwesomeIcon
                  icon={faSpinner}
                  spin={true}
                  size='2x'
                  color='#fff'
                />
              </div>
              <div className='fixed inset-0 z-40 bg-black opacity-25'></div>
            </>
          )}
        </div>
      </Layout>
    </>
  );
};

export default GuestPage;
